export enum QuotaGroups {
    Mantaghe1,
    Mantaghe2,
    Mantaghe3
}